(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9831],{

/***/ 46992:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tokenized-assets",
      function () {
        return __webpack_require__(14687);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O_": function() { return /* reexport safe */ _useIsClient__WEBPACK_IMPORTED_MODULE_2__.O; },
/* harmony export */   "f5": function() { return /* reexport safe */ _useEventLogs__WEBPACK_IMPORTED_MODULE_5__.f; }
/* harmony export */ });
/* harmony import */ var _useDebounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97486);
/* harmony import */ var _useFPTRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95249);
/* harmony import */ var _useIsClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17237);
/* harmony import */ var _useNFTMetadata__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56647);
/* harmony import */ var _useWalletNFTs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28372);
/* harmony import */ var _useEventLogs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27462);








/***/ }),

/***/ 14687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8395);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52494);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86893);
/* harmony import */ var react_wrap_balancer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41782);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38793);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44868);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46230);







const TokenizedAssets = ()=>{
    const isClient = (0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useIsClient */ .O_)();
    const { isConnected  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_4__/* .useAccount */ .mA)();
    const patentTextColor = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useColorModeValue */ .ff)("slate.600", "slate.400");
    const patentLinkColor = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useColorModeValue */ .ff)("brand.700", "brand.300");
    const cardBg = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useColorModeValue */ .ff)("white", "slate.800");
    const cardBorder = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useColorModeValue */ .ff)("slate.200", "slate.700");
    if (!isConnected && isClient) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .ConnectWallet */ .RZ, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        w: "full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                textAlign: "center",
                flexDir: "column",
                justifyContent: "center",
                alignItems: "center",
                my: "12",
                mx: "auto",
                maxW: "xl",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Badge */ .Ct, {
                        colorScheme: "green",
                        fontSize: "sm",
                        px: 3,
                        py: 1,
                        mb: 4,
                        children: "Tokenized Assets"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Heading */ .X6, {
                        mt: "2",
                        zIndex: "1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_wrap_balancer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            children: "Tokenized Real-World Asset Protection"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                        mt: "3",
                        zIndex: "1",
                        color: "slate.600",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_wrap_balancer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            children: "Cryptographically-bound surrogate tokens that secure tokenized representations of real-world assets — including treasuries, equities, and yield-bearing instruments — by providing immutable proof of ownership and enabling controlled transferability without compromising the underlying asset."
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                        fontSize: "xs",
                        color: patentTextColor,
                        mt: "2",
                        zIndex: "1",
                        children: [
                            "Protected by",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Link */ .rU, {
                                href: "/patents",
                                color: patentLinkColor,
                                textDecoration: "none",
                                _hover: {
                                    textDecoration: "underline"
                                },
                                children: "U.S. Patent No. 12,293,358"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W2, {
                maxW: "4xl",
                my: {
                    base: 8,
                    md: 12
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .SimpleGrid */ .MI, {
                    columns: {
                        base: 1,
                        md: 2
                    },
                    spacing: 6,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeatureCard, {
                            icon: react_icons_fi__WEBPACK_IMPORTED_MODULE_7__/* .FiDollarSign */ .oQC,
                            title: "Treasury & Yield Token Binding",
                            description: "Surrogate tokens cryptographically bound to tokenized treasury positions and yield-bearing instruments, ensuring verifiable proof of ownership on-chain.",
                            cardBg: cardBg,
                            cardBorder: cardBorder
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeatureCard, {
                            icon: react_icons_fi__WEBPACK_IMPORTED_MODULE_7__/* .FiShield */ .bfl,
                            title: "Asset Integrity Protection",
                            description: "Underlying real-world asset representations remain secured while surrogate tokens enable controlled interaction, preventing unauthorized transfers or manipulation.",
                            cardBg: cardBg,
                            cardBorder: cardBorder
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeatureCard, {
                            icon: react_icons_fi__WEBPACK_IMPORTED_MODULE_7__/* .FiLayers */ .yG,
                            title: "Multi-Chain RWA Verification",
                            description: "Prove ownership of tokenized real-world assets across multiple blockchain networks without migrating the underlying position or relying on third-party bridges.",
                            cardBg: cardBg,
                            cardBorder: cardBorder
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeatureCard, {
                            icon: react_icons_fi__WEBPACK_IMPORTED_MODULE_7__/* .FiRefreshCw */ .Bw1,
                            title: "Compliant Transferability",
                            description: "Enable controlled transfer and redemption workflows for tokenized securities and funds while maintaining compliance verification through on-chain surrogate token status.",
                            cardBg: cardBg,
                            cardBorder: cardBorder
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W2, {
                maxW: "4xl",
                mb: 12,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
                    p: 8,
                    borderWidth: "1px",
                    borderRadius: "lg",
                    borderColor: cardBorder,
                    bg: cardBg,
                    textAlign: "center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                        fontSize: "lg",
                        fontWeight: "medium",
                        children: [
                            "Contact",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Link */ .rU, {
                                href: "mailto:sales@foolproof.xyz",
                                color: patentLinkColor,
                                _hover: {
                                    textDecoration: "underline"
                                },
                                children: "sales@foolproof.xyz"
                            }),
                            " ",
                            "to get started"
                        ]
                    })
                })
            })
        ]
    });
};
const FeatureCard = (param)=>{
    let { icon , title , description , cardBg , cardBorder  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        p: 6,
        borderWidth: "1px",
        borderRadius: "lg",
        borderColor: cardBorder,
        bg: cardBg,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                align: "center",
                mb: 3,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO, {
                        as: icon,
                        boxSize: 6,
                        color: "brand.500",
                        mr: 3
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Heading */ .X6, {
                        size: "sm",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                fontSize: "sm",
                color: "slate.600",
                children: description
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (TokenizedAssets);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6893,9774,2888,179], function() { return __webpack_exec__(46992); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);